<template>
  <Transition name="slide-up" appear>
    <div v-if="visible" class="modal-center">
      <div class="modal-content">
        <div class="modal-header">
          <div class="header-left">
            <span class="modal-header-txt">{{$t('create_web_link')}}</span>
            <span class="modal-header-description">{{$t('create_web_link_description')}}</span>
          </div>

          <div @click="onHide" class="close-btn">
            <img class="cross" src="@/assets/images/cross.svg" />
          </div>
        </div>


        <div class="web-link-container">
          <span class="link-href" v-if="shortCode">https://web.ibilityapp.com/{{shortCode}}?programId={{programId}}</span>
          <span class="link-not-generated" v-else>{{$t('web_link_not_generated')}}</span>

          <button>
            <img src="@/assets/images/copyOutline.svg" @click="handleCopyCode" />
          </button>

          <button
              @click="onRefreshLink"
              :class="{'refreshing': isRefreshLink}"
              :disabled="isRefreshLink"
          >
            <img src="@/assets/images/refresh.svg" />
          </button>
        </div>

        <div v-if="packageLimitWebLink !== null && packageLimitWebLink !== undefined" class="limit-section">
          <div class="limit-display">
            <span class="limit-label">{{$t('web_link_usage')}}</span>
            <span class="limit-count">{{ shortCodeClickCount || 0 }} / {{ packageLimitWebLink }}</span>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import programService from "@/service/programService";
import {handleErrorResponse} from "@/utils/utils";

export default {
  components: {

  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {}
    },
    programId: {
      type: String,
      default: ''
    },
    oldShortCode: {
      type: String,
      default: null
    },
    packageLimitWebLink: {
      type: Number,
      default: null
    },
    shortCodeClickCount: {
      type: Number,
      default: 0
    }
  },
  watch: {
    oldShortCode(newVal) {
      this.shortCode = newVal;
    }
  },
  data() {
    return {
      baseUrl: 'https://web.ibilityapp.com/',
      isRefreshLink: false,
      shortCode: null,
    };
  },

  mounted() {},

  methods: {
    onRefreshLink() {
      if (!this.programId) {
        return;
      }

      this.isRefreshLink = true;

      programService.createWeblink(this.programId).then((response) => {
        if (response.data.data.shortCode) {
          this.shortCode = response.data.data.shortCode;
        } else {
          this.shortCode = null;
          this.$snackbar.add({
            text: this.$t('undefined_short_code'),
            type: 'error'
          });
        }

        this.isRefreshLink = false;
      }).catch((error) => {
        handleErrorResponse(error, this.$snackbar);
      })
    },
    handleCopyCode() {
      if (!this.shortCode) {
        this.$snackbar.add({
          text: this.$t('web_link_not_generated'),
          type: 'error'
        });
        return;
      }

      const copyText = `${this.baseUrl}${this.shortCode}?programId=${this.programId}`;
      navigator.clipboard.writeText(copyText).then(() => {
        this.onHide();
        this.$snackbar.add({
          text: this.$t('web_link_copied'),
          type: 'success'
        });
      }).catch((err) => {
        this.$snackbar.add({
          text: this.$t('web_link_copy_failed'),
          type: 'error'
        });
      });
    }
  },

};
</script>

<style scoped>
.modal-content {
  position: relative;
  background-color: white;
  width: 30%;
  border-radius: 12px;
  padding: 20px;
  overflow-y: auto;
  max-height: calc(100vh - 48px);
}

.modal-content::-webkit-scrollbar {
  width: 15px;
}

.modal-content::-webkit-scrollbar-track {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #FFF;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: rgba(4, 12, 45, 0.2);
  border-radius: 10px;
  border: 5px transparent solid;
  background-clip: padding-box;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(4, 12, 45, 0.4);
}

.close-btn {
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 3000px;
}

.cross{
  padding: 8px;
}

.modal-header{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  border: none;
}

.header-left {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.modal-header-txt{
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 18px;
  font-style: normal;
  line-height: 18px;
}

.modal-header-description {
  font-family: euclid_regular, sans-serif;
  color: #6B7280;
  font-size: 14px;
  font-style: normal;
  line-height: 16px;
}

h5 {
  font-family: euclid_medium, sans-serif;
  color: #010511;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 20px;
}

.web-link-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  border-radius: 24px;
  background-color: #F5F5F5;
  padding: 5px 12px;
  margin-top: 25px;
}

.link-href {
  font-family: euclid_regular, sans-serif;
  color: #040C2D;
  font-size: 14px;
  line-height: 20px;
  flex-grow: 1;
  display: block;
}

.link-not-generated {
  font-family: euclid_regular, sans-serif;
  color: #6B7280;
  font-size: 12px;
  line-height: 20px;
  flex-grow: 1;
}

.web-link-container button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  border-radius: 24px;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.web-link-container button img {
  width: 20px;
  height: 20px;
  transition: background-color 0.2s;
}

.web-link-container button:hover {
  background-color: #E5E7EB;
}

.web-link-container button.refreshing img {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform:rotate(0deg);
  }
  to {
    transform:rotate(360deg);
  }
}

.limit-section {
  margin-top: 20px;
  padding: 10px;
  background-color: #F5F5F5;
  border-radius: 24px;
}

.limit-display {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.limit-label {
  font-family: euclid_medium, sans-serif;
  color: #374151;
  font-size: 12px;
  line-height: 20px;
}

.limit-count {
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 14px;
  line-height: 20px;
}
</style>
